import { render, staticRenderFns } from "./CustomerStatus.vue?vue&type=template&id=362fa632&scoped=true&"
import script from "./CustomerStatus.vue?vue&type=script&lang=js&"
export * from "./CustomerStatus.vue?vue&type=script&lang=js&"
import style0 from "./CustomerStatus.vue?vue&type=style&index=0&id=362fa632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362fa632",
  null
  
)

export default component.exports